import Polyglot from 'node-polyglot';

import englishTranslation from './en.json';
import germanTranslation from './de.json';
import spanishTranslation from './es.json';
import frenchTranslation from './fr.json';
import dutschTranslation from './nl.json';

const locales = {
  en: englishTranslation,
  de: germanTranslation,
  es: spanishTranslation,
  fr: frenchTranslation,
  nl: dutschTranslation,
};

/**
 * Get I18n
 * @param string/bool lang
 * @return object polyglot
 */
function getI18n(lang: string | null = null) {
  if (lang !== null && lang !== undefined && locales[lang] !== undefined) {
    return new Polyglot({ phrases: locales[lang], locale: lang });
  }
  let locale = 'en';
  const language =
    (navigator.languages && navigator.languages[0]) ||
    navigator.language ||
    // @ts-ignore
    navigator.userLanguage;
  if (locales[language]) {
    locale = language;
  } else {
    const langNoRegion = language.toLowerCase().split(/[_-]+/)[0];
    if (locales[langNoRegion]) {
      locale = langNoRegion;
    }
  }
  return new Polyglot({ phrases: locales[locale], locale });
}

const polyglotUIComponents = (lang: string | null = null) => getI18n(lang);

export default polyglotUIComponents;
